import { useEffect, useState } from 'react';
import { appConfig } from '../wysiwyg/appConfig';
import {
  defaultPreviewLayouts,
  getPreviewLayouts,
  loadPreviewLayouts,
} from '../wysiwyg/previewLayouts';
import type { PreviewLayout } from '../wysiwyg/types';

export function usePreviewLayouts(layoutsEndpoint?: string): PreviewLayout[] {
  const [layouts, setLayouts] = useState<PreviewLayout[]>(defaultPreviewLayouts);

  useEffect(() => {
    let cancelled = false;

    loadPreviewLayouts(
      layoutsEndpoint || appConfig.previewLayoutsEndpoint,
      defaultPreviewLayouts,
      { api: { getPreviewLayouts } },
    ).then((result) => {
      if (!cancelled) setLayouts(result);
    });

    return () => {
      cancelled = true;
    };
  }, [layoutsEndpoint]);

  return layouts;
}
